import env from '../../env.json';
import shopifyBuy from 'shopify-buy/index.unoptimized.umd';

export const shopifyClient = shopifyBuy.buildClient({
  domain: 'shop.supercluster.com',
  storefrontAccessToken: env.SHOPIFY_STOREFRONT_ACCESS_TOKEN
});
